import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useShop } from '../context/ShopContext';
import { ChevronRight } from 'lucide-react';

export default function CategoryGrid() {
  const navigate = useNavigate();
  const { activeCategory, setActiveCategory, categories } = useShop();

  const safeCats = Array.isArray(categories) ? categories : [];
  const displayCategories = safeCats.filter(c => c && c.isFeatured !== false);

  const handleSelect = (id) => {
    setActiveCategory(id);
    navigate(`/category/${id}`);
  };

  if (displayCategories.length === 0) return null;

  return (
    <section style={{ padding: '0 0 20px', backgroundColor: '#f1f3f6' }}>
      <div className="container">
        
        {/* Flipkart White Card Section */}
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '2px',
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.1)',
          overflow: 'hidden'
        }}>
          {/* Section Header */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px 20px',
            borderBottom: '1px solid #f0f0f0'
          }}>
            <div>
              <h2 style={{
                fontSize: '1.28rem',
                fontWeight: 700,
                color: '#212121'
              }}>
                Featured Categories • Top Curation
              </h2>
              <span style={{ fontSize: '0.78rem', color: '#878787' }}>
                100% Hallmarked gold, certified diamonds and heavy silverware
              </span>
            </div>

            <button
              onClick={() => { setActiveCategory('all'); navigate('/category/all'); }}
              style={{
                backgroundColor: '#2874f0',
                color: '#ffffff',
                border: 'none',
                borderRadius: '2px',
                fontSize: '0.82rem',
                fontWeight: 600,
                padding: '8px 18px',
                cursor: 'pointer',
                textTransform: 'uppercase'
              }}
            >
              VIEW ALL
            </button>
          </div>

          {/* Categories Horizontal Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: '12px',
            padding: '16px'
          }} className="fk-category-grid">
            {displayCategories.map((cat) => {
              const title = cat.name || cat.title || 'Collection';
              return (
                <div
                  key={cat.id}
                  onClick={() => handleSelect(cat.id)}
                  style={{
                    backgroundColor: '#ffffff',
                    border: '1px solid #f0f0f0',
                    borderRadius: '2px',
                    padding: '16px 12px',
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    transition: 'all 0.2s ease',
                    position: 'relative'
                  }}
                  className="fk-category-card"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 3px 12px rgba(0, 0, 0, 0.1)';
                    e.currentTarget.style.borderColor = '#2874f0';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.borderColor = '#f0f0f0';
                  }}
                >
                  {/* Category Image */}
                  <div style={{
                    width: '130px',
                    height: '130px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '12px',
                    overflow: 'hidden'
                  }}>
                    <img
                      src={cat.image}
                      alt={title}
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                        transition: 'transform 0.3s ease'
                      }}
                      className="fk-cat-thumb"
                    />
                  </div>

                  {/* Title */}
                  <h3 style={{
                    fontSize: '0.92rem',
                    fontWeight: 600,
                    color: '#212121',
                    marginBottom: '4px',
                    lineHeight: 1.2
                  }}>
                    {title}
                  </h3>

                  {/* Flipkart Green Offer Tag */}
                  <span style={{
                    fontSize: '0.78rem',
                    color: '#388e3c',
                    fontWeight: 700,
                    marginBottom: '2px'
                  }}>
                    {cat.badge ? cat.badge : 'Min. 15% Off'}
                  </span>

                  <span style={{
                    fontSize: '0.72rem',
                    color: '#878787'
                  }}>
                    {cat.subtitle || 'Shop Now'}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

      </div>

      <style>{`
        @media (max-width: 640px) {
          .fk-category-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 8px !important;
            padding: 10px !important;
          }
          .fk-category-card {
            padding: 10px 8px !important;
          }
        }
        .fk-category-card:hover .fk-cat-thumb {
          transform: scale(1.08);
        }
      `}</style>
    </section>
  );
}
